import { Button } from "@svea/design-system-components-react";
import {
	Markdown,
	openBankIdApp,
	Stack,
	type TranslationTexts,
	useLogin,
	useText,
} from "@sveabank/cc-common";
import QrCode from "../../components/qr-code";

const loginStatusText = ({
	qrCode,
	hasScanned,
	isAuthorized,
	isSameDevice,
	texts,
}: {
	qrCode: string | null;
	hasScanned: boolean;
	isAuthorized: boolean;
	isSameDevice: boolean;
	texts: TranslationTexts;
}) => {
	// todo: improve this logic when we can receive hintCode from bank id api:
	return isAuthorized
		? texts.loginPage.loginInProgress.descriptionAuthorized
		: isSameDevice
			? texts.loginPage.loginInProgress.descriptionSameDevice
			: !hasScanned
				? qrCode
					? texts.loginPage.loginInProgress.descriptionStart
					: texts.loginPage.loginInProgress.descriptionInitializing
				: texts.loginPage.loginInProgress.descriptionScanned;
};

const LoginInProgress = () => {
	const { cancelLogin, qrCode, isSameDevice, loginState, tokens } = useLogin();

	const [t, texts] = useText();

	const onCancel = async () => {
		await cancelLogin();
	};

	const onOpenBankIdApp = () => {
		if (tokens.bearerToken) openBankIdApp(tokens.bearerToken);
	};

	return (
		<Stack fullSize justify="between">
			<Stack grow={false} gap={4} align="center">
				<QrCode qrCode={isSameDevice ? null : qrCode} />
				{/* todo: fix markdown component to support line breaks instead of using className: */}
				<Markdown className="text-center whitespace-pre-wrap">
					{t(
						loginStatusText({
							qrCode,
							hasScanned: false,
							isAuthorized: loginState === "LOGGED_IN",
							isSameDevice,
							texts,
						}),
					)}
				</Markdown>
				{!isSameDevice && (
					<Button
						variant="primary"
						width="full"
						isDisabled={loginState === "LOGGED_IN"}
						onPress={onOpenBankIdApp}
					>
						{t(texts.loginPage.buttonTextSameDevice)}
					</Button>
				)}
				<Button
					width="full"
					type="button"
					onPress={onCancel}
					variant="secondary"
					isDisabled={loginState === "LOGGED_IN"}
				>
					{t(texts.common.abort)}
				</Button>
			</Stack>
		</Stack>
	);
};

export default LoginInProgress;
